module.exports = __webpack_public_path__ + "media/images/steps/step_4-975d12191b9a2a49d96b0e2da432c4ee.svg";